export default __webpack_public_path__ + "static/media/EM0540.34I-22667_-15280_0.0c87f583.jpg";